module.exports = __webpack_public_path__ + "static/gm-16-698ccccbb0ac94c3e3815a2a6243aa95.jpg";